import * as STD from '@emersya/mpa-std';
import * as CM from '@emersya/mpa-components-manager';

export interface IImageComponentConfiguration extends CM.DOMComponent.IConfiguration {
	URL?: string;
};

export class ImageComponent extends CM.DOMComponent<
	HTMLImageElement,
	ImageComponent,
	IImageComponentConfiguration
> {
	component_DOM: HTMLImageElement;

	async update(URL: string) {
		if (URL.startsWith('$ASSETS')) {
			URL = URL.replace('$ASSETS/', (<any>window).app.clientAppParameters.app.assetsPath);
		}

		if (URL.endsWith('.svg')) {
			if (this.component_DOM.hasChildNodes()) {
				if (this.component_DOM.children[0] && this.component_DOM.children[0].getAttribute('data-url') === URL) {
					return;
				}
				this.component_DOM.children[0]?.remove();
			}
			const response = await fetch(URL);
			if (!response.ok) {
				this.component_throwUserError('Wrong URL for svg', {URL: URL});
			}
			const svgResponse = STD.DOM.parse(await response.text(), 'image/svg+xml');
			svgResponse.documentElement.setAttribute('data-url', URL);
			this.component_DOM.appendChild(svgResponse.documentElement);
		} else {
			if (this.component_DOM.children[0] && this.component_DOM.children[0].hasAttribute('src')) {
				if (this.component_DOM.children[0].getAttribute('src') === URL) {
					return;
				}
				this.component_DOM.children[0].setAttribute('src', URL);
			} else if (this.component_DOM.children[0]) {
				this.component_DOM.children[0]?.remove();
				this.component_DOM.appendChild(<HTMLImageElement>STD.DOM.factory({
					tag: 'img',
					attributes: {
						'data-translation-attr': 'alt:' + <string>this.component_getTranslationId('name'),
						'src': URL
					}
				}));
			} else {
				this.component_DOM.appendChild(<HTMLImageElement>STD.DOM.factory({
					tag: 'img',
					attributes: {
						'data-translation-attr': 'alt:' + <string>this.component_getTranslationId('name'),
						'src': URL
					}
				}));
			}
		}
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: IImageComponentConfiguration
	) {
		super(descriptor, configuration);
		if (!this.component_hasTranslation('name')) {
			this.component_throwUserError('Translation<name> not defined!', {});
		}
		this.component_DOM = <HTMLImageElement>STD.DOM.factory({
			tag: 'div',
			attributes: {}
		});
		if (configuration.URL) {
			void this.update(configuration.URL);
		}
	};
};
export namespace NS {
	export const Component = ImageComponent;
	export type Component = ImageComponent;
	export type Configuration = IImageComponentConfiguration;
}

import './Image.scss';

CM.Manager.declare({
	id: 'image',
	type: ImageComponent
});
